import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { IncidentsActivityPanelDataProviderFactory } from '../factory/IncidentsActivityPanelDataProviderFactory';
import { IncidentsActivityPanelBaseDataProvider } from '../dataProvider/IncidentsActivityPanelBaseDataProvider';
import { IncidentsActivityPanelWebComponentSchema } from '../types';

export class IncidentsActivityPanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IncidentsActivityPanelDataProviderFactory;
  public dataProvider: IncidentsActivityPanelBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IncidentsActivityPanelDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<IncidentsActivityPanelWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
